export class UnitsModel{
    unCode ='';
    unName = '';
    unArName = '';
    unrach =  '0';
    compCode = '1';
    userID = 'sa';
    modifiedDate = '2021-01-01';
}
